import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { hasRole } from "@/js/http/auth";
import { listUserGroups, listCurrencies, casingWines, COUNTRIES, pricePostingUsaProConstants } from "@/js/lists.ts";
import { ERROR_DATA, getErrorData, handleErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterDecimal2digitsKey } from "@/js/events/keycodes.js";
import { formatPrice, getSymbolCurrency, roundToTwoDigit } from "@/js/currency/currencies.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import WineNaming from "@/components/products/WineNaming.vue";
import ScheduledWineConditionalDiscountsModal from "@/components/conditionaldiscount/ScheduledWineConditionalDiscountsModal.vue";
import PricePostedUsaEditModal from "@/components/price-posting/usa-pro/PricePostedUsaEditModal.vue";
export default {
  name: "ConditionalDiscountV2Modal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal,
    WineNaming: WineNaming,
    ScheduledWineConditionalDiscountsModal: ScheduledWineConditionalDiscountsModal,
    PricePostedUsaEditModal: PricePostedUsaEditModal
  },
  props: {
    wineId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      shown: false,
      options: {
        color: "primary",
        zIndex: 2000
      },
      canManagePricePosting: false,
      panel: [1],
      addingDiscount: {
        isPending: false,
        cancellationToken: null,
        form: {
          countryId: null,
          stateId: null,
          userGroup: null,
          treshold: null,
          newPriceCurrencyIncludeDefaultShipping: null,
          currency: null,
          isValid: false
        }
      },
      deletingDiscount: {
        isPending: false,
        cancellationToken: null
      },
      listDefaultCurrencies: [],
      listThresholds: [{
        value: 6,
        label: "6 bottles"
      }, {
        value: 12,
        label: "12 bottles"
      }, {
        value: 36,
        label: "36 bottles"
      }, {
        value: 60,
        label: "60 bottles"
      }, {
        value: 120,
        label: "120 bottles"
      }, {
        value: 300,
        label: "300 bottles"
      }],
      gettingCountries: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      gettingWine: {
        isPending: false,
        cancellationToken: null,
        result: {}
      },
      gettingDiscounts: {
        isPending: false,
        cancellationToken: null,
        results: [],
        tableHeaders: [{
          text: "Country/State",
          value: "country",
          align: "left"
        }, {
          text: "Group",
          value: "userGroup",
          align: "left"
        }, {
          text: "Min quantity",
          value: "treshold",
          align: "center"
        }, {
          text: "Price",
          value: "priceCurrency",
          align: "center"
        }, {
          text: "",
          value: "action",
          align: "right"
        }]
      },
      gettingUserIdExemple: {
        isPending: false,
        cancellationToken: null,
        showWarningMessageUserExemple: false
      },
      gettingCurrentPrice: {
        isPending: false,
        cancellationToken: null,
        result: null
      },
      isScheduledDiscountsModalShown: false,
      formRules: formRules,
      listUserGroups: listUserGroups,
      casingWines: casingWines,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.addingDiscount.isPending || this.deletingDiscount.isPending;
    },
    isAnyLoadInProgress: function isAnyLoadInProgress() {
      return this.gettingWine.isPending || this.gettingCountries.isPending || this.gettingDiscounts.isPending;
    },
    derivedUserGroups: function derivedUserGroups() {
      return [{
        id: "HORECA",
        value: listUserGroups.find(function (x) {
          return x.id === "HORECA";
        }).name
      }, {
        id: "WHOLESALER",
        value: listUserGroups.find(function (x) {
          return x.id === "WHOLESALER";
        }).name
      }, {
        id: "USER",
        value: listUserGroups.find(function (x) {
          return x.id === "USER";
        }).name
      }];
    },
    countryChosenStates: function countryChosenStates() {
      var _this$gettingCountrie,
        _this$gettingCountrie2,
        _this2 = this;
      if (this.addingDiscount.form.countryId > 0) return (_this$gettingCountrie = (_this$gettingCountrie2 = this.gettingCountries.results) === null || _this$gettingCountrie2 === void 0 || (_this$gettingCountrie2 = _this$gettingCountrie2.states) === null || _this$gettingCountrie2 === void 0 ? void 0 : _this$gettingCountrie2.filter(function (x) {
        return x.id_country === _this2.addingDiscount.form.countryId;
      })) !== null && _this$gettingCountrie !== void 0 ? _this$gettingCountrie : [];
    },
    addingDiscountCanFetchCurrentPrice: function addingDiscountCanFetchCurrentPrice() {
      var _this$addingDiscount$;
      return this.addingDiscount.form.countryId > 0 && ((_this$addingDiscount$ = this.addingDiscount.form.userGroup) === null || _this$addingDiscount$ === void 0 ? void 0 : _this$addingDiscount$.length) > 0;
    },
    addingDiscountPriceRules: function addingDiscountPriceRules() {
      var _this$gettingCurrentP;
      var rules = [this.formRules.mustBeGreaterThan0];
      if ((_this$gettingCurrentP = this.gettingCurrentPrice) !== null && _this$gettingCurrentP !== void 0 && _this$gettingCurrentP.result) {
        rules.push(this.formRules.mustBeLowerThan(this.gettingCurrentPrice.result.customerPriceIncludeDefaultShippingCurrency));
      }
      return rules;
    },
    addingDiscountGrossMargin: function addingDiscountGrossMargin() {
      var _this$gettingCurrentP2;
      if ((_this$gettingCurrentP2 = this.gettingCurrentPrice) !== null && _this$gettingCurrentP2 !== void 0 && _this$gettingCurrentP2.result && this.addingDiscount.form.newPriceCurrencyIncludeDefaultShipping > 0) {
        var defaultShippingCurrency = this.gettingCurrentPrice.result.defaultShippingPerBottleCurrency;
        var revenueCurrency = this.addingDiscount.form.newPriceCurrencyIncludeDefaultShipping - defaultShippingCurrency;
        var cogsCurrency = this.gettingWine.result.cogs_euro_ex_vat * this.gettingCurrentPrice.result.currencyRate;
        if (revenueCurrency <= 0) {
          return "Too low to be calculated";
        }
        return roundToTwoDigit((revenueCurrency - cogsCurrency) / revenueCurrency * 100);
      } else {
        return "?";
      }
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this3.canManagePricePosting = hasRole(process.env.VUE_APP_ROLES_MANAGE_PRICE_POSTING);
            _this3.getCountries();
            _this3.getWine();
            _this3.getDiscounts();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getFormattedMonthYear: function getFormattedMonthYear(date) {
      if (!(date instanceof Date)) {
        date = new Date(date);
      }
      return date.formatStringMonth();
    },
    getCountries: function getCountries() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this4$gettingCountri, _this4$gettingCountri2;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.gettingCountries.isPending = true;
              (_this4$gettingCountri = _this4.gettingCountries.cancellationToken) === null || _this4$gettingCountri === void 0 || _this4$gettingCountri.cancel();
              _this4.gettingCountries.cancellationToken = axios.CancelToken.source();
              _this = _this4;
              _context2.next = 6;
              return request("/v1/countries/protected?implantedMarket=true", "GET", null, true, "api", null, _this.gettingCountries.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of countries", true);
                  handleErrorData(_this, errorData);
                }
                _this.gettingCountries.isPending = false;
                throw e;
              });
            case 6:
              response = _context2.sent;
              _this4.gettingCountries.results = {
                countries: _toConsumableArray(response.data.countries),
                states: _toConsumableArray(response.data.states.filter(function (x) {
                  return !pricePostingUsaProConstants.map(function (s) {
                    return s.idState;
                  }).includes(x.id_state);
                }))
              };
              if (((_this4$gettingCountri2 = _this4.gettingCountries.results.countries) === null || _this4$gettingCountri2 === void 0 ? void 0 : _this4$gettingCountri2.length) === 1) {
                _this4.addingDiscount.form.countryId = _this4.gettingCountries.results.countries[0].id_country;
              } else if (_this4.gettingCountries.results.countries.some(function (x) {
                return x.id_country === COUNTRIES.USA.id;
              })) {
                _this4.addingDiscount.form.countryId = COUNTRIES.USA.id;
              }
              _this4.verifyCurrencies();
              _this4.gettingCountries.isPending = false;
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    changeCountry: function changeCountry() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.addingDiscount.form.stateId = null;
              _this5.verifyCurrencies();
              _this5.$nextTick(function () {
                _this5.getCurrentPrice();
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    changeState: function changeState() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.$nextTick(function () {
                _this6.getCurrentPrice();
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    changeUserGroup: function changeUserGroup() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this7.$nextTick(function () {
                _this7.getCurrentPrice();
              });
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    changeCurrency: function changeCurrency() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this8.$nextTick(function () {
                _this8.getCurrentPrice();
              });
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getWine: function getWine() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this9$gettingWine$ca;
        var data, _this, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this9.gettingWine.isPending = true;
              (_this9$gettingWine$ca = _this9.gettingWine.cancellationToken) === null || _this9$gettingWine$ca === void 0 || _this9$gettingWine$ca.cancel();
              _this9.gettingWine.cancellationToken = axios.CancelToken.source();
              data = {
                id_wines: [_this9.wineId],
                calculatePrices: false,
                bypassStockSeek: true
              };
              _this = _this9;
              _context7.next = 7;
              return request("/v1/wines", "POST", data, true, "api", null, _this.gettingWine.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get wine data", true);
                  handleErrorData(_this, errorData);
                }
                _this.gettingWine.isPending = false;
                throw e;
              });
            case 7:
              response = _context7.sent;
              _this9.gettingWine.result = _objectSpread({}, response.data.wines[0]);
              _this9.gettingWine.isPending = false;
            case 10:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getCurrentPrice: function getCurrentPrice() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var userId, _this10$gettingCurren, data, _this, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this10.gettingCurrentPrice.result = null;
              _context8.next = 3;
              return _this10.getUserIdExemple();
            case 3:
              userId = _context8.sent;
              if (!(userId > 0)) {
                _context8.next = 15;
                break;
              }
              _this10.gettingCurrentPrice.isPending = true;
              (_this10$gettingCurren = _this10.gettingCurrentPrice.cancellationToken) === null || _this10$gettingCurren === void 0 || _this10$gettingCurren.cancel();
              _this10.gettingCurrentPrice.cancellationToken = axios.CancelToken.source();
              data = {
                id_wines: [_this10.wineId],
                userIdTarget: userId,
                isApplyActivePricePostingByDefault: false,
                calculatePrices: true,
                bypassStockSeek: true
              };
              _this = _this10;
              _context8.next = 12;
              return request("/v1/wines", "POST", data, true, "api", null, _this.gettingCurrentPrice.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get current price", true);
                  handleErrorData(_this, errorData);
                }
                _this.gettingCurrentPrice.isPending = false;
                throw e;
              });
            case 12:
              response = _context8.sent;
              _this10.gettingCurrentPrice.result = _objectSpread({}, response.data.wines[0]);
              _this10.gettingCurrentPrice.isPending = false;
            case 15:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    getUserIdExemple: function getUserIdExemple() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this11$gettingUserId, data, paramsQuery, _this, response, userIdExemple;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (_this11.addingDiscountCanFetchCurrentPrice) {
                _context9.next = 4;
                break;
              }
              return _context9.abrupt("return", 0);
            case 4:
              _this11.gettingUserIdExemple.isPending = true;
              (_this11$gettingUserId = _this11.gettingUserIdExemple.cancellationToken) === null || _this11$gettingUserId === void 0 || _this11$gettingUserId.cancel();
              _this11.gettingUserIdExemple.cancellationToken = axios.CancelToken.source();
              data = {
                userGroup: _this11.addingDiscount.form.userGroup,
                countryId: _this11.addingDiscount.form.countryId
              };
              if (_this11.addingDiscount.form.stateId > 0) {
                data.stateId = _this11.addingDiscount.form.stateId;
              }
              paramsQuery = Object.encodeToUri(data);
              _this = _this11;
              _context9.next = 13;
              return request("/v1/users/exemple?params=".concat(paramsQuery), "GET", data, true, "api", null, _this.gettingUserIdExemple.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get user exemple", true);
                  handleErrorData(_this, errorData);
                }
                _this.gettingUserIdExemple.isPending = false;
                throw e;
              });
            case 13:
              response = _context9.sent;
              userIdExemple = +response.data.value;
              _this11.gettingUserIdExemple.showWarningMessageUserExemple = userIdExemple <= 0;
              return _context9.abrupt("return", +response.data.value);
            case 17:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    getDiscounts: function getDiscounts() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this12$gettingDiscou;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this12.gettingDiscounts.isPending = true;
              (_this12$gettingDiscou = _this12.gettingDiscounts.cancellationToken) === null || _this12$gettingDiscou === void 0 || _this12$gettingDiscou.cancel();
              _this12.gettingDiscounts.cancellationToken = axios.CancelToken.source();
              _this = _this12;
              _context10.next = 6;
              return request("/v1/conditionals-discounts-v2/".concat(_this12.wineId), "get", null, true, "api", null, _this12.gettingDiscounts.cancellationToken).catch(function (e) {
                _this.$toasted.show("Unable to load the conditionals discounts.", {
                  type: "error"
                });
                _this.gettingDiscounts.isPending = true;
                throw e;
              });
            case 6:
              response = _context10.sent;
              _this12.gettingDiscounts.results = _toConsumableArray(response.data.value.items);
              _this12.gettingDiscounts.isPending = false;
            case 9:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    startEditDiscount: function startEditDiscount(item) {
      this.addingDiscount.form = {
        countryId: item.countryId,
        stateId: item.stateId,
        userGroup: item.userGroup,
        treshold: item.treshold,
        newPriceCurrencyIncludeDefaultShipping: item.discountAmountIncludeDefaultShipping,
        currency: item.discountCurrency,
        isValid: true
      };
      this.panel = [].concat(_toConsumableArray(this.panel), [0]);
      this.getCurrentPrice();
    },
    addDiscount: function addDiscount() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this13$addingDiscoun;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this13.addingDiscount.isPending = true;
              (_this13$addingDiscoun = _this13.addingDiscount.cancellationToken) === null || _this13$addingDiscoun === void 0 || _this13$addingDiscoun.cancel();
              _this13.addingDiscount.cancellationToken = axios.CancelToken.source();
              data = _objectSpread({}, _this13.addingDiscount.form);
              delete data.isValid;
              _this = _this13;
              _context11.next = 8;
              return request("/v1/conditionals-discounts/".concat(_this13.wineId), "POST", data, true, "api", null, _this.addingDiscount.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions);
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
                _this.addingDiscount.isPending = false;
                throw e;
              });
            case 8:
              _this13.$toasted.show("Discount saved", {
                type: "success"
              });
              _this13.addingDiscount.isPending = false;
              _this13.addingDiscount.form.newPriceCurrencyIncludeDefaultShipping = null;
              _this13.addingDiscount.form.treshold = null;
              _this13.getDiscounts();
            case 13:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    confirmDeleteDiscount: function confirmDeleteDiscount(item) {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var ok;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return _this14.$refs.confirm.open("Delete", "Are you sure you want to delete this discount ?", {
                color: "red"
              });
            case 2:
              ok = _context12.sent;
              if (ok) {
                _this14.deleteDiscount(item);
              }
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    deleteDiscount: function deleteDiscount(item) {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this15$deletingDisco;
        var _this;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _this15.deletingDiscount.isPending = true;
              (_this15$deletingDisco = _this15.deletingDiscount.cancellationToken) === null || _this15$deletingDisco === void 0 || _this15$deletingDisco.cancel();
              _this15.deletingDiscount.cancellationToken = axios.CancelToken.source();
              _this = _this15;
              _context13.next = 6;
              return request("/v1/conditionals-discounts/".concat(item.commissionId), "delete", null, true, "api", null, _this15.deletingDiscount.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.deletingDiscount.isPending = false;
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to delete the discount.", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 6:
              _this15.deletingDiscount.isPending = false;
              _this15.getDiscounts();
            case 8:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    verifyCurrencies: function verifyCurrencies() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this16$listDefaultCu;
        var availableCurrencies, _this16$user, country;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              availableCurrencies = [];
              if (_this16.addingDiscount.form.countryId > 0) {
                if (_this16.addingDiscount.form.countryId === COUNTRIES.USA.id) {
                  availableCurrencies = ["USD"];
                } else if (((_this16$user = _this16.user) === null || _this16$user === void 0 || (_this16$user = _this16$user.delivery_address) === null || _this16$user === void 0 || (_this16$user = _this16$user.country) === null || _this16$user === void 0 ? void 0 : _this16$user.id_country) === COUNTRIES.BAHAMAS.id) {
                  availableCurrencies = ["BSD", "USD"];
                } else {
                  country = _this16.gettingCountries.results.countries.find(function (x) {
                    return x.id_country === _this16.addingDiscount.form.countryId;
                  });
                  availableCurrencies.push(country.currency);
                  if (country.currency != "EUR") {
                    availableCurrencies.push("EUR");
                  }
                }
              }
              _this16.listDefaultCurrencies = listCurrencies.filter(function (x) {
                return availableCurrencies.includes(x.id);
              });
              if (!availableCurrencies.includes(_this16.addingDiscount.form.currency)) {
                _this16.addingDiscount.form.currency = null;
              }
              if (!_this16.addingDiscount.form.currency && ((_this16$listDefaultCu = _this16.listDefaultCurrencies) === null || _this16$listDefaultCu === void 0 ? void 0 : _this16$listDefaultCu.length) > 0) {
                if (_this16.addingDiscount.form.countryId === COUNTRIES.BRAZIL.id && availableCurrencies.includes("EUR")) {
                  _this16.addingDiscount.form.currency = "EUR";
                } else {
                  _this16.addingDiscount.form.currency = availableCurrencies[0];
                }
              }
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }))();
    },
    openPricesPostingEditModal: function openPricesPostingEditModal() {
      var _this17 = this;
      this.$nextTick(function () {
        _this17.$refs.PricePostedUsaEditModalRef.open();
      });
    },
    openScheduledDiscounts: function openScheduledDiscounts() {
      var _this18 = this;
      this.isScheduledDiscountsModalShown = true;
      this.$nextTick(function () {
        _this18.$refs.ScheduledDiscountsModal.open();
      });
    },
    closeScheduledDiscounts: function closeScheduledDiscounts() {
      this.isScheduledDiscountsModalShown = false;
    },
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency,
    filterDecimal2digitsKey: filterDecimal2digitsKey
  }
};